module.exports = __webpack_public_path__ + "media/buy_report_icons/foreign_data-7ccb38d8.svg";